import { render, staticRenderFns } from "./AttributeInputTag.vue?vue&type=template&id=0683835a"
import script from "./AttributeInputTag.vue?vue&type=script&lang=js"
export * from "./AttributeInputTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports